import React from 'react';
import { StyledBadge } from './index.style';

const Badge = ({ children }) => (
  <StyledBadge variant="body-12-medium">{children}</StyledBadge>
);

export default Badge;
